import React, { Fragment, useState, useEffect } from 'react';
import Grid from "../../../Grid";
import Button from "../../../Button";
import { Controller, useForm } from 'react-hook-form';
import makeAnimated from 'react-select/animated';
import styles from "./WorkOrder.module.sass";
import Select from 'react-select'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OrderPackage from '../../../../models/OrderPackage';
import Option from '../../../../models/Option';
import Package from '../../../../models/Package';
import axios from 'axios';
import School from "../../../../models/School";
import Student from "../../../../models/Student";
import AsyncSelect from 'react-select/async'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const animatedComponents = makeAnimated();

const Form = ({ workOrderTypes, detailFields = {}, modelType, modelId, schoolName, studentName, studentID, teacher, email, phone  }) => {
  // shouldUnregister: a detail field from a previously-selected type unmounts when
  // the type changes, so its (possibly required) registration is dropped instead of
  // silently blocking submit.
  const { register, handleSubmit, control, trigger, watch, setValue, unregister, formState: { errors } } = useForm({ shouldUnregister: true });
  defaultValues: {
      expedite: false;
      school_request: false;
    }
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderPackages, setOrderPackages] = useState();
  const [school, setSchool] = useState();
  const [students, setStudents] = useState();
  const [selectedWorkOrderType, setSelectedWorkOrderType] = useState({});
  const orderId = watch('order_id');
  const studentId = watch('student_id');

  useEffect(() => {
    if (!orderId) return;

    OrderPackage
      .includes(['apiOption', 'package'])
      .where({ order_id: orderId })
      .all()
      .then((response) => {
        setOrderPackages(response.data)
      })
      .catch((e) => {
        toast('There was no order found with that ID. Please double check the ID and enter again', { type: 'error' })
      });
  }, [orderId])

  useEffect(() => {
    if (!studentId) return;

    Student
      .where({ school_id: school, is_enrolled: true, student_id: studentId })
      .all()
      .then((response) => {
        setStudents(response.data)
      })
      .catch((e) => {
        toast('There was no student found with that ID. Please double check the ID and enter again', { type: 'error' })
      });
  }, [studentId])

  const workOrderTypesForForm = () => {
    if (modelType) {
      const filteredWorkOrderTypes = Object.entries(workOrderTypes).filter(([, v]) => v === modelType);
      const filteredObject = Object.fromEntries(filteredWorkOrderTypes);
      return (
        Object.keys(filteredObject)
          .map((workOrderType) => ({ value: workOrderType, label: workOrderType }))
      )
    }

    return (
      Object.keys(workOrderTypes).map((workOrderType) => ({ value: workOrderType, label: workOrderType }))
    )
  }

  const modelForWorkOrderType = () => {
    return workOrderTypes[selectedWorkOrderType.value]
  }

  const orderPackageFormOptions = () => (
    orderPackages.map((orderPackage) => (
      { label: `${orderPackage.package.slug} - Package ${orderPackage.apiOption && orderPackage.apiOption.name}`, value: orderPackage.id }
    ))
  )

  const studentFormOptions = () => (
    students.map((student) => (
      { label: `${student.fullName()} ID: ${student.studentId}`, value: student.id }
    ))
  )

  const loadSchoolOptionsQuery = ({ valueField }) => (value, callback) => {
    School
      .where({
        sales_stat: { match: 'CUST' },
        name: { match: value },
      })
      .order({ name: 'asc' })
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadSchoolOptions = loadSchoolOptionsQuery('name')

  const renderFormInputs = () => {
    if (modelType === 'School' || modelType === 'Student') {
      return (
        <>
          <label className={styles.label}>Assigned To</label>
          <input
            className={`${styles.input} ${styles.textInput}`}
            {...register("assigned_to")}
          />

          <div>
            <label className={styles.label}>Promised Date</label>
            <Controller
              control={control}
              name="promised_date"
              render={({ field }) => (
                <DatePicker selected={field.value || Date.now()}
                            showTimeSelect
                            onChange={(date) => field.onChange(date)}
                            className={styles.input} />
              )}
            />
          </div>

          <div>
            <label className={styles.label}>Delivery Date</label>
            <Controller
              control={control}
              name="delivery_date"
              render={({ field }) => (
                <DatePicker selected={field.value || Date.now()}
                            showTimeSelect
                            onChange={(date) => field.onChange(date)}
                            className={styles.input} />
              )}
            />
          </div>
        </>
      )
    }
    else if (modelForWorkOrderType() === 'Student') {
      return (
        <>
          <label className={styles.label}>School</label>
          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder="Select the school for the student"
            name={name}
            loadOptions={loadSchoolOptions}
            onChange={(opt) => setSchool(opt.value)}
          />

          {school && (
            <>
              <label className={styles.label}>Student ID</label>
              <input
                className={`${styles.input} ${styles.textInput}`}
                {...register("student_id", { required: modelForWorkOrderType() === 'student' })}
              />
            </>
          )}

          {students && (
            <Controller
              control={control}
              name="model_id"
              render={({ field: { onChange, value } }) => (
                <Select
                  {...register("model_id", { required: true })}
                  onChange={({ value: newValue }) => {
                    onChange({ label: newValue, value: newValue });
                  }}
                  className="basic-single"
                  components={animatedComponents}
                  placeholder="For which student?"
                  options={studentFormOptions()}
                />
              )}
            />
          )}
        </>
      )
    } else if (modelForWorkOrderType() === 'OrderPackage') {
      return (
        <>
          <label className={styles.label}>Order ID</label>
          <input
            className={`${styles.input} ${styles.textInput}`}
            {...register("order_id", { required: modelForWorkOrderType() === 'OrderPackage' })}
          />

          {orderPackages && (
            <Controller
              control={control}
              name="model_id"
              render={({ field: { onChange, value } }) => (
                <Select
                  {...register("model_id", { required: true })}
                  onChange={({ value: newValue }) => {
                    onChange({ label: newValue, value: newValue });
                  }}
                  className="basic-single"
                  components={animatedComponents}
                  placeholder="For which item?"
                  options={orderPackageFormOptions()}
                />
              )}
            />
          )}
        </>
      )
    }
  }

  // Type-specific fulfillment fields, driven by the WorkOrder::TYPE_FIELDS catalog
  // passed from the server. Registered under `details.<key>`; the server prunes to
  // the selected type's keys, so stale values from a prior type are dropped.
  const renderDetailFields = () => {
    const fields = detailFields[selectedWorkOrderType.value] || []
    if (!fields.length) return null

    return fields.map((field) => (
      <div key={field.key}>
        <label className={styles.label}>{field.label}{field.required ? ' *' : ''}</label>
        {field.type === 'textarea' ? (
          <textarea
            className={`${styles.input} ${styles.textInput}`}
            {...register(`details.${field.key}`, { required: field.required })}
          />
        ) : field.type === 'select' ? (
          <select className={styles.input} {...register(`details.${field.key}`, { required: field.required })}>
            <option value="">Select...</option>
            {field.options.map((opt) => (<option key={opt} value={opt}>{opt}</option>))}
          </select>
        ) : (
          <input
            type={field.type === 'number' ? 'number' : 'text'}
            className={`${styles.input} ${styles.textInput}`}
            {...register(`details.${field.key}`, { required: field.required })}
          />
        )}
      </div>
    ))
  }

  const onSubmit = (data) => {
    const params = {
      work_order: {
        work_order_type: data.work_order_type.value,
        model_id: modelId || data.model_id.value,
        school_request: data.school_request,
        expedite: data.expedite,
        model_type: modelType || modelForWorkOrderType(),
        notes: data.notes,
        assigned_to: data.assigned_to,
        delivery_date: data.delivery_date,
        promised_date: data.promised_date,
        originated_by: data.originated_by,
        details: data.details || {}
      }
    }

    setIsSubmitting(true)
    axios
      .post("/admin/work_orders.json", params)
      .then((data) => {
        window.location = `/admin/work_orders/${data.data}/edit`
      })
      .catch(() => {
        setIsSubmitting(false)
        toast.error("Something went wrong creating the work order. Please refresh and try again.", {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  }

  return (
    <Fragment>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        {schoolName && studentName && (
          <div>School: {schoolName} Student: {studentName}</div>
          
        )}
        <Controller
          control={control}
          name="work_order_type"
          render={({ field: { onChange, value } }) => (
            <>
              <label className={styles.label}>Select work order type</label>
              <Select
                {...register("work_order_type", { required: true })}
                onChange={({ value: newValue }) => {
                  onChange({ label: newValue, value: newValue });
                  setSelectedWorkOrderType({ label: newValue, value: newValue });
                }}
                className="basic-single"
                components={animatedComponents}
                placeholder="Work order type"
                options={workOrderTypesForForm()}
              />
            </>
          )}
        />
        {renderFormInputs()}
        {renderDetailFields()}

        <label className={styles.label}>Notes</label>
        <textarea
          className={`${styles.input} ${styles.textInput}`}
          {...register("notes")}
        />

        <label className={styles.label}>Originated By</label>
        <input
          className={`${styles.input} ${styles.textInput}`}
          {...register("originated_by")}
          placeholder="Who originated this work order?"
        />

        <div className={styles.formGroup}>
          <input
            type="checkbox"
            className={styles.checkBox}
            {...register("school_request")}
          />
          <label className={styles.label}>Was this work order requested by a school?</label>
        </div>
        <div className={styles.formGroup}>
          <input
            type="checkbox"
            className={styles.checkBox}
            {...register("expedite")}
          />
          <label className={styles.label}>Is this work order expedited/rush?</label>
        </div>

        <Button
          classes={styles.submit}
          fullWidth
          variant='submit'
          disabled={isSubmitting}
        >
          Submit
        </Button>
      </form>
    </Fragment>
  )
}

export default Form;
